export const topbar = {
  clientNone: "Kein Mandant",
  clientSelect: "Mandanten auswählen",
  partnerNone: "Kein Partner",
  partnerSelect: "Partner auswählen",
  projectNone: "Kein Projekt",
  projectSelect: "Projekt auswählen",
  welcome: "Willkommen"
};
